import React from 'react';
import { Link } from 'react-router-dom';
import { DOWNLOAD_LINK_LIST } from '../config/pocketBillingAiDownloadLinks';

/**
 * @param {{ compact?: boolean, showViewAll?: boolean, downloadPagePath?: string, contactHref?: string }} props
 */
export default function PocketBillingAiDownloadLinksSection({
  compact = false,
  showViewAll = true,
  downloadPagePath = '/pocketbillingai/download',
  contactHref = '/pocketbillingai#contact',
}) {
  return (
    <div className={compact ? 'space-y-4' : 'space-y-6'}>
      {!compact ? (
        <div className="text-center max-w-2xl mx-auto mb-8 sm:mb-10">
          <p className="text-indigo-600 text-xs sm:text-sm font-semibold tracking-widest uppercase mb-2">
            Download
          </p>
          <h2 className="text-2xl sm:text-4xl font-bold text-stone-900 mb-3">
            Install PocketBillingAI on your devices
          </h2>
          <p className="text-stone-600 text-sm sm:text-base">
            Version <strong>1.9.8</strong> — desktop (Mac &amp; Windows) and Android. After install, sign in with the
            mobile number registered by our team. Need help?{' '}
            <a href={contactHref} className="text-indigo-600 hover:underline">
              Contact us
            </a>
            .
          </p>
        </div>
      ) : null}

      <div className="grid sm:grid-cols-2 gap-4 sm:gap-5">
        {DOWNLOAD_LINK_LIST.map((item) => (
          <a
            key={item.id}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col rounded-2xl border border-stone-200 bg-white p-5 sm:p-6 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all text-left"
          >
            <div className="flex items-start gap-3 mb-3">
              <span className="text-2xl sm:text-3xl" aria-hidden>
                {item.icon}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-semibold text-stone-900 group-hover:text-indigo-700">{item.label}</h3>
                <p className="text-xs text-stone-500 mt-0.5">{item.requirements}</p>
              </div>
            </div>
            {!compact ? (
              <p className="text-sm text-stone-600 leading-relaxed mb-4 flex-1">{item.description}</p>
            ) : (
              <p className="text-sm text-stone-600 mb-4 flex-1 line-clamp-2">{item.description}</p>
            )}
            <span className="inline-flex items-center justify-center gap-2 w-full sm:w-auto sm:self-start px-4 py-2.5 rounded-xl bg-indigo-600 group-hover:bg-indigo-700 text-white text-sm font-semibold transition-colors">
              {item.cta}
              <span aria-hidden>↗</span>
            </span>
          </a>
        ))}
      </div>

      {showViewAll && compact ? (
        <p className="text-center">
          <Link
            to={downloadPagePath}
            className="inline-flex text-sm font-semibold text-indigo-600 hover:text-indigo-800"
          >
            Full download guide &amp; system requirements →
          </Link>
        </p>
      ) : null}

      <p className="text-xs text-stone-500 text-center max-w-xl mx-auto">
        Mac apps may show an &quot;unidentified developer&quot; warning — right-click the app → Open, or allow in System
        Settings → Privacy &amp; Security.
      </p>
    </div>
  );
}
